import React, { memo } from 'react';

import { Typography } from 'antd';

const NoticeProductPending = () => {
  return (
    <Typography.Text className='block'>
      Seu produto ainda não foi aprovado na moderação, para iniciar as vendas é necessário que o mesmo esteja aprovado.
    </Typography.Text>
  );
};

export default memo(NoticeProductPending);
